import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';

import { paths } from 'src/routes/paths';
import { useInView } from 'src/hooks/use-in-view';
import { mergeClasses } from 'src/utils/merge-classes';
import { SectionHead } from 'src/components/section-head';

const CARD_PATHS: Record<string, string | undefined> = {
  contact: paths.contact,
  tools: paths.services.tools,
  agents: paths.services.agents,
  secureAi: paths.services.secureAi,
  migrations: paths.services.migrations,
  implementations: paths.services.implementations,
};

type ServiceCardItem = {
  id: string;
  more: string;
  text: string;
  title: string;
  tickText: string;
  tickHighlight: string;
};

function ServiceCard({ item }: { item: ServiceCardItem }) {
  const { ref, inView } = useInView<HTMLAnchorElement>();
  const to = CARD_PATHS[item.id];

  if (!to) {
    return null;
  }

  return (
    <Link to={to} ref={ref} className={mergeClasses('card', 'reveal', inView && 'visible')}>
      <span className="tick">
        <b>{item.tickHighlight}</b> {item.tickText}
      </span>
      <h3>{item.title}</h3>
      <p>{item.text}</p>
      <span className="more">
        {item.more} <span className="arrow">→</span>
      </span>
    </Link>
  );
}

export function HomeServices() {
  const { t } = useTranslation('home');
  const items = t('services.items', { returnObjects: true });

  return (
    <section id="services" className="section flush-top">
      <div className="container">
        <SectionHead title={t('services.title')} eyebrow={t('services.eyebrow')} />
        <div className="grid-3">
          {items.map((item) => (
            <ServiceCard item={item} key={item.id} />
          ))}
        </div>
      </div>
    </section>
  );
}
